import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';


const Header = () => {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  const toggleSearch = () => {
    setIsSearchOpen(!isSearchOpen);
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    document.body.classList.toggle('mobile-menu-visible', !isOpen);
  };

  const handleSearch = async (value) => {
    if (value.trim() === '') {
      setSearchResults([]);
      return;
    }
    try {
      const response = await axios.post('https://www.hum.ujn.mybluehostin.me/new_clinet/snkb_api/search.php', 
        new URLSearchParams({ searchValue: value })
      );
      setSearchResults(response.data);
    } catch (error) {
      console.error('Error searching:', error);
    }
  };

  useEffect(() => {
    handleSearch(searchValue);
  }, [searchValue]);

  // Handle window resize events
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768 && isOpen) {
        setIsOpen(false);
        document.body.classList.remove('mobile-menu-visible');
      }
    };
    
    window.addEventListener('resize', handleResize);

    // Clean up event listener on unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isOpen]);

  // Handle page navigation
  useEffect(() => {
    const handleRouteChange = () => {
      if (isOpen) {
        setIsOpen(false);
        document.body.classList.remove('mobile-menu-visible');
      }
    };

    window.addEventListener('popstate', handleRouteChange);

    return () => {
      window.removeEventListener('popstate', handleRouteChange);
    };
  }, [isOpen]);

  return (
    <div>


      <div className="boxed_wrapper">
        <div className="header-top" style={{ backgroundColor: '#d21a05' }}>
          <div className="row justify-content-center">
            <div className="col-lg-12 col-md-12 col-sm-12 text-center">
              <div className="text-center" style={{ padding: '8px 0px' }}>
                <div className="text">
                  <h5 style={{ color: '#fff' }}>"Your Reliable Source for Genuine SNKB Bearings, Crafted with Precision in Japan"</h5>
                </div>
              </div>
            </div>
          </div>
        </div>

        <header className="main-header">
          <div className="header-top">
            {/* Header Top content here */}
          </div>
          <div className="header-lower">
            <div className="outer-container">
              <div className="outer-box">
                <div className="menu-left-content" style={{ padding: '0px', borderRight: 'none' }}>
                  <figure className="logo-box">
                    <Link  to="/">
                      <img
                        src="/assets/images/snkb-logo.png"
                        style={{ width: '187px', height: '100px', paddingTop: '5px', paddingBottom: '5px' }}
                        alt="SNKB Logo"
                      />
                    </Link>
                  </figure>
                  <div className="search-box-outer search-toggler">
                    <h5 onClick={toggleSearch}><i className="flaticon-loupe"></i>Search</h5>
                  </div>
                </div>
                <div className="menu-area clearfix">
                  <div className="mobile-nav-toggler" onClick={toggleMenu}>
                    <i className="icon-bar"></i>
                    <i className="icon-bar"></i>
                    <i className="icon-bar"></i>
                  </div>
                  <nav className="main-menu navbar-expand-md navbar-light">
                    <div className="collapse navbar-collapse show clearfix" id="navbarSupportedContent">
                      <ul className="navigation clearfix">
                        <li><Link  to="/">Home</Link></li>
                        <li className="dropdown"><Link  to="#">About Us</Link>
                          <ul>
                            <li><Link  to="/About_Us">About Us</Link></li>
                            <li><Link  to="/SNKB_History">History</Link></li>
                          </ul>
                        </li>
                        <li><Link  to="/Our_Category">Our Products</Link></li>
                        <li><Link  to="/Contact_Us">Contact Us</Link></li>
                      </ul>
                    </div>
                  </nav>
                </div>
                <div className="menu-right-content" style={{ padding: '-1px', borderLeft: 'none' }}>
                  <div className="btn-box">
                    <div className="icon-box"><i className="flaticon-headphones"></i></div>
                    <Link  to="/Contact_Us">Get a quote<i className="flaticon-right-chevron"></i></Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="sticky-header">
            <div className="outer-container">
              <div className="outer-box">
                <div className="menu-left-content" style={{ padding: '3px', borderRight: 'none' }}>
                  <figure className="logo-box">
                    <Link  to="/">
                      <img
                        src="/assets/images/snkb-logo.png"
                        style={{ width: '187px', height: '100px', paddingTop: '5px', paddingBottom: '5px' }}
                        alt="SNKB Logo"
                      />
                    </Link>
                  </figure>
                  <div className="search-box-outer search-toggler">
                    <h5 onClick={toggleSearch}><i className="flaticon-loupe"></i>Search</h5>
                  </div>
                </div>
                <div className="menu-area clearfix">
                  <nav className="main-menu clearfix">
                    <ul className="navigation clearfix">
                      <li><Link  to="/">Home</Link></li>
                      <li className="dropdown"><Link  to="#">About Us</Link>
                        <ul>
                          <li><Link  to="/About_Us">About Us</Link></li>
                          <li><Link  to="/SNKB_History">History</Link></li>
                        </ul>
                      </li>
                      <li><Link  to="/Our_Category">Our Products</Link></li>
                      <li><Link  to="/Contact_Us">Contact Us</Link></li>
                    </ul>
                  </nav>
                </div>
                <div className="menu-right-content" style={{ borderLeft: 'none' }}>
                  <div className="btn-box">
                    <div className="icon-box"><i className="flaticon-headphones"></i></div>
                    <Link  to="/Contact_Us">Get a quote<i className="flaticon-right-chevron"></i></Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>

        <div className={`mobile-menu ${isOpen ? 'open' : ''}`}>
          <div className="menu-backdrop" onClick={toggleMenu}></div>
          <div className="close-btn" onClick={toggleMenu}><i className="fas fa-times"></i></div>

          <nav className="menu-box">
            <div className="nav-logo">
              <Link  to="/">
                <img src="/assets/images/snkb-logo.png" style={{ width: '185px', height: '80px', filter: 'brightness(0) invert(1)' }} alt="" title="" />
              </Link>
            </div>
            <div className="menu-outer">
              <div className="collapse navbar-collapse show clearfix" id="navbarSupportedContent">
                <ul className="navigation clearfix">
                  <li><Link  to="/">Home</Link></li>
                  <li className="dropdown"><Link  to="#">About Us</Link>
                  <li><Link  to="/About_Us">About Us</Link></li>
                      <li><Link  to="/SNKB_History">History</Link></li>
                  </li>
                  <li><Link  to="/Our_Category">Our Products</Link></li>
                  <li><Link  to="/Contact_Us">Contact Us</Link></li>
                </ul>
              </div>
            </div>

            <div className="contact-info">
              <h4>Contact Info</h4>
              <ul>
                <li>109 Swastik Disa Corporate Park, LBS Rd, Nityanand Nagar, Ghatkopar West, Mumbai</li>
                <li><Link  to="tel:+919930400377">+91 9930400377</Link></li>
                <li><Link  to="mailto:info@snkbbearing.com">info@snkbbearing.com</Link></li>
              </ul>
            </div>
            <div className="social-links">
              <ul className="clearfix">
                <li><Link  to="/"><span className="fab fa-twitter"></span></Link></li>
                <li><Link  to="/"><span className="fab fa-facebook-square"></span></Link></li>
                <li><Link  to="/"><span className="fab fa-pinterest-p"></span></Link></li>
                <li><Link  to="/"><span className="fab fa-instagram"></span></Link></li>
                <li><Link  to="/"><span className="fab fa-youtube"></span></Link></li>
              </ul>
            </div>
          </nav>
        </div>

        <div>
          {isSearchOpen && (
            <div id="search-popup" className="search-popup popup-visible">
              <div className="popup-inner">
                <div className="upper-box clearfix">
                  <figure className="logo-box pull-left">
                    <Link  to="/">
                      <img
                        src="assets/images/snkb-logo.png"
                        style={{ width: 187, height: 100, paddingTop: 5, paddingBottom: 5 }}
                        alt=""
                      />
                    </Link>
                  </figure>
                  <div className="close-search pull-right" onClick={toggleSearch}>
                    <i className="fa-solid fa-xmark" />
                  </div>
                </div>
                <div className="overlay-layer" />
                <div className="auto-container">
                  <div className="search-form">
                    <div className="form-group">
                      <fieldset>
                        <input
                          type="search"
                          className="form-control"
                          name="search-input"
                          value={searchValue}
                          onChange={(e) => setSearchValue(e.target.value)}
                          placeholder="Search Bearing NO, ID, and OD"
                          required=""
                        />
                      </fieldset>
                    </div>
                    <div className="row" style={{ paddingTop: '10px' }}>
  {Array.isArray(searchResults) && searchResults.length > 0 ? (
    searchResults.map((result) => (
      <div key={result.ID} className="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-3 shop-block">
        <a href={`/Product_Details?proid=${result.ID}`}>
          <div className="shop-block-one">
            <div className="inner-box">
              <div className="new-boxx">
                <div className="offer-box" />
                <figure className="image">
                  <img src={`assets/img/${result.category_img}`} alt={result.category_name} />
                </figure>
              </div>
              <div className="lower-content">
                <h5>Bearing No: {result.B_NO}</h5>
                <p>{result.category_name}</p>
                <div className="review-box" />
              </div>
            </div>
          </div>
        </a>
      </div>
    ))
  ) : (
    searchValue ? "Product not found" : " "
  )}
</div>

                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Header;
